export default "__VITE_ASSET__AaKXEF7A__"